import FormLocationProvince from '../Province/index.js'
import FormLocationSearch from '../Search/index.js'

export const TYPES = {
  PROVINCE: 'province',
  SEARCH: 'search'
}

export const COMPONENTS = {
  [TYPES.PROVINCE]: FormLocationProvince,
  [TYPES.SEARCH]: FormLocationSearch
}

export const DEFAULT_TYPE = TYPES.SEARCH

export const OPTIONS = [
  {literal: 'Municipio / CP', value: TYPES.SEARCH},
  {literal: 'Provincia', value: TYPES.PROVINCE}
]
